/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileType,
    CaseFileTypeFromJSON,
    CaseFileTypeFromJSONTyped,
    CaseFileTypeToJSON,
    ErrorReason,
    ErrorReasonFromJSON,
    ErrorReasonFromJSONTyped,
    ErrorReasonToJSON,
    UploadBatchProcessingStatus,
    UploadBatchProcessingStatusFromJSON,
    UploadBatchProcessingStatusFromJSONTyped,
    UploadBatchProcessingStatusToJSON,
    UploadFileInfo,
    UploadFileInfoFromJSON,
    UploadFileInfoFromJSONTyped,
    UploadFileInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFileUploadBatch
 */
export interface CaseFileUploadBatch {
    /**
     * 
     * @type {string}
     * @memberof CaseFileUploadBatch
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileUploadBatch
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileUploadBatch
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileUploadBatch
     */
    startedByUserId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileUploadBatch
     */
    batchCreationDate?: Date;
    /**
     * 
     * @type {UploadBatchProcessingStatus}
     * @memberof CaseFileUploadBatch
     */
    status?: UploadBatchProcessingStatus;
    /**
     * 
     * @type {Array<UploadFileInfo>}
     * @memberof CaseFileUploadBatch
     */
    files?: Array<UploadFileInfo> | null;
    /**
     * 
     * @type {CaseFileType}
     * @memberof CaseFileUploadBatch
     */
    type?: CaseFileType;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileUploadBatch
     */
    batchCompletedTimestamp?: Date | null;
    /**
     * 
     * @type {{ [key: string]: ErrorReason; }}
     * @memberof CaseFileUploadBatch
     */
    errorResults?: { [key: string]: ErrorReason; } | null;
}

export function CaseFileUploadBatchFromJSON(json: any): CaseFileUploadBatch {
    return CaseFileUploadBatchFromJSONTyped(json, false);
}

export function CaseFileUploadBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileUploadBatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'startedByUserId': !exists(json, 'startedByUserId') ? undefined : json['startedByUserId'],
        'batchCreationDate': !exists(json, 'batchCreationDate') ? undefined : (new Date(json['batchCreationDate'])),
        'status': !exists(json, 'status') ? undefined : UploadBatchProcessingStatusFromJSON(json['status']),
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(UploadFileInfoFromJSON)),
        'type': !exists(json, 'type') ? undefined : CaseFileTypeFromJSON(json['type']),
        'batchCompletedTimestamp': !exists(json, 'batchCompletedTimestamp') ? undefined : (json['batchCompletedTimestamp'] === null ? null : new Date(json['batchCompletedTimestamp'])),
        'errorResults': !exists(json, 'errorResults') ? undefined : (json['errorResults'] === null ? null : mapValues(json['errorResults'], ErrorReasonFromJSON)),
    };
}

export function CaseFileUploadBatchToJSON(value?: CaseFileUploadBatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'caseId': value.caseId,
        'userId': value.userId,
        'startedByUserId': value.startedByUserId,
        'batchCreationDate': value.batchCreationDate === undefined ? undefined : (value.batchCreationDate.toISOString()),
        'status': UploadBatchProcessingStatusToJSON(value.status),
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(UploadFileInfoToJSON)),
        'type': CaseFileTypeToJSON(value.type),
        'batchCompletedTimestamp': value.batchCompletedTimestamp === undefined ? undefined : (value.batchCompletedTimestamp === null ? null : value.batchCompletedTimestamp.toISOString()),
        'errorResults': value.errorResults === undefined ? undefined : (value.errorResults === null ? null : mapValues(value.errorResults, ErrorReasonToJSON)),
    };
}


